import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppNotAvailableComparisonAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        label="Not available comparison alert"
        placeholder="Select not available comparison alert"
        urlAjax={`${BACKEND_APIS.CRUD}/user/not_available_comparison?selectorFormat=true`}
        {...props}
    />
}